import { cn } from "@/libs/utils";

type InputType = "text" | "number" | "password";
type Props = {
  type?: InputType;
  defaultValue: string | number;
  placeholder?: string;
  className?: string;
  onChange?: (value: any) => void;
  onFocus?: (value: any) => void;
  onBlur?: (value: any) => void;
  onKeyDownEnter?: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
};
export default function CommonInput({
  type = "text",
  defaultValue = "",
  placeholder,
  className,
  onChange,
  onFocus,
  onBlur,
  onKeyDownEnter,
  disabled,
  maxLength,
}: Props) {
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") onKeyDownEnter?.(e.target.value);
  };
  return (
    <input
      className={cn(
        "h-[30px] px-[8px] py-[4px] border-[1px] border-gray-D rounded-[4px] text-[10px] placeholder:text-gray-C",
        className
      )}
      type={type === "password" ? type : "text"}
      maxLength={maxLength}
      value={
        type === "number" ? Number(defaultValue).toLocaleString() : defaultValue
      }
      placeholder={placeholder}
      onChange={(e) => {
        const value =
          type === "number"
            ? Number(e.target.value.replace(/[^0-9]/g, ""))
            : e.target.value;
        onChange?.(value);
      }}
      onFocus={(e) => onFocus?.(e.target.value)}
      onBlur={(e) => {
        const value =
          type === "number"
            ? Number(e.target.value.replace(/[^0-9]/g, ""))
            : e.target.value;
        onBlur?.(value);
      }}
      onKeyDown={(e) => {
        if (e.nativeEvent.isComposing) return;
        handleKeyDown(e);
      }}
      disabled={disabled}
    />
  );
}
